<template>
	<div class="page solution">
		<TopSubMenu :menu = "$store.state.gnb.menuList[1].subCategory"></TopSubMenu>

		<!-- solution -->
		<section class="secWrap solutionWrap">
			<div class="boardList">
				<div class="solutionItem" v-for="(item, index) in solution.list" :id="item.id" :key="'solutionItem' + index" :style="{ backgroundImage: 'url(' + item.bgImg.url + ')' }" >
					<div class="topImg" data-aos="fade-up">
						<div class="imgWrap">
							<img :src="item.topImg.url" alt="">
						</div>
					</div>
					<div class="bottomWrap">
						<div class="leftSide">
							<div class="innerContent" data-aos="fade-left">
								<p class="subTitleTxt">{{item.subtitle}}</p>
								<h3 class="titleTxt"  :style="{ color: item.solutionName.color }">
									{{item.solutionName.txt}}
								</h3>
								<p class="subTxt" v-html="item.subTxt"></p>
								<BtnLink class="btnLink" size="is-medium" :routerLink="`solution/${item.routeId}`"></BtnLink>
							</div>
						</div>
						<div class="rightSide">
							<div class="innerContent">
								<p data-aos="fade" class="txt" v-html="item.explanation"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<Footer/>
	</div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import BtnLink from '../components/ButtonLinkPage'
import TopSubMenu from '../components/TopSubMenu'
import Footer from '../components/Footer'

export default {
	name: 'Solution',
	components: {
		BtnLink,
		TopSubMenu,
		Footer
	},
	data () {
		return {
			solution: {
				listType: true, // <br>로 쪼개짐
				bullet: 'hyphen', // null, 'hyphen', 'dot', 'dotBox'
				list: [
					/* {
						id: 'webnote',
						topImg: { url: require('@/assets/images/img-solution-fcnote@2x.png') },
						bgImg: { url: require('@/assets/images/bg-solution-fcnote@2x.jpg') },
						solutionName: { txt: 'TS Web FC Note', color: '#9E00CC' },
						subtitle: 'Non-ActiveX. Non-Plugin!',
						subTxt: '어떠한 프로그램도 설치할 필요없는 HTML5 기반<br>100% 순수 Web 필기 메모 컴포넌트',
						explanation: '100% Pure html5 based Touch Drawing Tool<br>Non ActiveX, Non Plug-in<br>for Multi-device<br>add to as-is as Component<br>현장에서 ODS, mSFA 실행 중 포스트잇 메모처럼 사용 가능',
						link: '/solutionfcnote'
					},
					*/
				]
			}
		}
	},
	mounted () {
		// data load
		// soltion list data load
		this.$axios.post(this.$store.state.dataUrl + '/twosonSolutionList')
			.then(response => {
				console.log('solutionData : ', response.data)
				let data = response.data
				let dataObj
				let tempData
				let tempSubTxt
				this.solution.list = []
				for (var elm in data) {
					dataObj = {}
					tempData = data[elm]
					console.log('this.listType:', this.listType)
					if (this.solution.listType) {
						// tempSubTxt = tempData.content.characteristic.split('<br>').join('</li><li>')
						tempSubTxt = tempData.content.characteristic.split(/\r\n|\r|\n/).join('</li><li>')
						tempSubTxt = '<ul class="list' + (this.solution.bullet ? ' ' + this.solution.bullet : '') + '"><li>' + tempSubTxt + '</li></ul>'
						console.log('tempSubTxt:', tempSubTxt)
					} else {
						tempSubTxt = tempData.content.characteristic
					}
					dataObj = {
						id: 'solutionItem' + tempData.solutionNo,
						topImg: {
							url: this.$store.getters.getUrlPrefix + tempData.mainImg
						},
						bgImg: {
							url: this.$store.getters.getUrlPrefix + tempData.bgImg
						},
						solutionName: { txt: tempData.title, color: tempData.color },
						subtitle: tempData.subTitle,
						subTxt: tempData.explanation,
						explanation: tempSubTxt,
						routeId: tempData.solutionNo
					}
					console.log(dataObj)
					this.solution.list.push(dataObj)
				}
			})
			.catch(error => {
				console.log('* solutionData error : ', error.response)
			})
	},
	created () {
		AOS.init({
			duration: 600,
			easing: 'ease-in-sine',
			delay: 100
		})
	},
	destroyed () {},
	methods: {}
}
</script>
<style lang="scss">
@import '@/css/variables.scss';
.solution {
	ul {
		&.list {
			li {
				margin-bottom: 5px;
			}
		}
		&.hyphen {
			li {
				position: relative;
				display: block;
				padding-left: 10px;
				&::before {
					display: block;
					position: absolute;
					left: 0;
					content: "-";
				}
			}
		}
		&.dotBox {
			$size: 3px;
			li {
				position: relative;
				display: block;
				padding-left: 10px;
				&::before {
					content: "";
					display: block;
					position: absolute;
					left: 0; top: calc(50% - #{$size});
					width: $size; height: $size;
					background-color: $c-gray-light2;
				}
			}
		}
		&.dot {
			$size: 4px;
			li {
				position: relative;
				display: block;
				padding-left: 10px;
				&::before {
					content: "";
					display: block;
					position: absolute;
					left: 0; top: calc(50% - #{$size});
					width: $size; height: $size;
					border-radius: $size;
					background-color: $c-gray-light2;
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';
.page {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-gray-light;
	.secWrap {
		width: 100%;
		padding: 0;
		margin: 0 auto;
		.boardList {
			width: 100%;
			.solutionItem {
				width: 100%;
				background-size: cover;
				background-attachment: fixed;
				background-position: top center;

				.topImg {
					height: 574px;
					img {
						height: 84%;
						width: auto;
						max-width: none;
					}
				}

				.bottomWrap {
					$pd: 40px;
					position: relative;
					display: flex;
					// align-items: center;
					.leftSide{
						width: 50%;
						background-color: rgba($c-gray-bright, 0.8);
						.innerContent {
							position: relative;
							width: $mxW/2;
							height: 100%;
							margin: 0 0 0 auto;
							padding: $pd $pd $pd 0;
							color: $c-gray;
							.subTitleTxt {
								font-size: $title-tiny;
								margin-bottom: 7px;
							}
							.titleTxt {
								font-size: $title-huge-small;
								margin-bottom: 12px;
								font-weight: bold;
								letter-spacing: $lspace-short;
							}
							.subTxt {
								width: 90%;
								font-size: $text-small;
							}
							.btnLink {
								position: absolute;
								bottom: $pd/2;
								right: $pd/2;
							}
						}
					}
					.rightSide {
						width: 50%;
						background-color: rgba($c-white, 0.9);
						display: flex; align-self: stretch; align-items: center;
						.innerContent {
							position: relative;
							width: $mxW/2;
							margin: 0 auto 0 $pd;
							justify-items: center;
							.txt {
								font-size: $text-small;
								color: $c-gray-m;
								line-height: 1.6em;
								word-break: keep-all;
							}
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
	/* .page .secWrap .boardList {
		width: $mxWDTSmall - $scrW;
	} */
	.page .secWrap .boardList .solutionItem .bottomWrap .leftSide .innerContent {
		padding: 40px;
		width: 100%;
	}
	.page .secWrap .boardList .solutionItem .bottomWrap .rightSide .innerContent {
		width: 100%;
		padding: 40px;
		margin: 0;
	}
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//css
	/* .page .secWrap .boardList {
		width: $mxWTablet - $scrW;
	} */
	.page .secWrap .boardList .solutionItem .bottomWrap .leftSide .innerContent {
		padding: 40px;
		width: 100%;
	}
	.page .secWrap .boardList .solutionItem .bottomWrap .rightSide .innerContent {
		width: 100%;
		padding: 40px;
		margin: 0;
	}
}

/*
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
	/* .page .secWrap .boardList {
		width: $mxWTablet - $scrW;
	} */
	.page .secWrap .boardList .solutionItem .bottomWrap .leftSide .innerContent {
		padding: 40px;
		width: 100%;
	}
	.page .secWrap .boardList .solutionItem .bottomWrap .rightSide .innerContent {
		width: 100%;
		padding: 40px;
		margin: 0;
	}
}

/*
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//CSS
	.page .secWrap .boardList .solutionItem .bottomWrap .leftSide .innerContent {
		padding: 30px 20px 45px;
		width: 100%;
		.titleTxt {
			font-size: $title-small;
		}
		.subTitleTxt {
			font-size: $text-tiny;
			margin:0;
		}
		.subTxt {
			width: 100%;
		}
		.btnLinkWrap {
			width: 40px;
			height: 40px;
			&.btnLink {
				bottom: 5px;
			}
		}
	}
	.page .secWrap .boardList .solutionItem .bottomWrap .rightSide .innerContent {
		width: 100%;
		padding: 30px 20px;
		margin: 0;
	}
	.page .secWrap .boardList .solutionItem {
		padding-bottom: 5px;
		background-size: cover;
		background-attachment: scroll;
		background-repeat: no-repeat;
		.topImg {
			height: 270px;
			.imgWrap {
				img {height: 70%;}
			}
		}
		.bottomWrap
		{
			flex-wrap: wrap;
			width: calc(100% - 10px);
			border-radius: 11px;
			overflow: hidden;
			margin: 0 auto 5px;
			.leftSide {
				width: 100%;
			}
			.rightSide {
				width: 100%;
			}
		}
	}
}

/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	.page .secWrap .boardList .solutionItem .bottomWrap .leftSide .innerContent {
		padding: 30px 20px 45px;
		width: 100%;
		.titleTxt {
			font-size: $title-small;
		}
		.subTitleTxt {
			font-size: $text-tiny;
			margin:0;
		}
		.subTxt {
			width: 100%;
		}
		.btnLinkWrap {
			width: 40px;
			height: 40px;
			&.btnLink {
				bottom: 5px;
			}
		}
	}
	.page .secWrap .boardList .solutionItem .bottomWrap .rightSide .innerContent {
		width: 100%;
		padding: 30px 20px;
		margin: 0;
		.txt {
			font-size: 14px;
			ul {
				li {
					margin-bottom: 10px;
				}
			}
		}
	}
	.page .secWrap .boardList .solutionItem {
		padding-bottom: 5px;
		background-size: cover;
		background-attachment: scroll;
		background-repeat: no-repeat;
		.topImg {
			height: 270px;
			.imgWrap {
				img {height: 70%;}
			}
		}
		.bottomWrap
		{
			flex-wrap: wrap;
			width: calc(100% - 10px);
			border-radius: 11px;
			overflow: hidden;
			margin: 0 auto 5px;
			.leftSide {
				width: 100%;
			}
			.rightSide {
				width: 100%;
			}
		}
	}

}
</style>
